export class RegistrationFeedbackElement {

  //  RegistrationFeedbackModel

  AdmissionFeedbackId:number;
  AdmissionMasterId:number;
  FeedBackDateTime:string;  FeedBackDate:string;
  FeedbackResult :string;

  OperationType :string;   CreatedBy :number;   MachineIP :string;
  Notes:string;

  AdmissionCategorizeId :number;

  FeedbackNature:string;OperatorsOpinion:string;
  HealthIssue :string ;
  HealthCondition:number;  
  HealthMotion:number;    HealthUrination:number;    HealthSleep:number; 
  IsAttendanceRegular :string ;   AttendanceLastVisited :string ;
  // HealthConditionFirst:number;  HealthConditionLast:number; 
  GuestRating:number;
  


  }
